import {View, Text, TouchableOpacity} from 'react-native';
import React, {useEffect, useState} from 'react';
import {Colors} from '../../constants/Colors';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {styles} from './styles';
import Header from '../../components/Header/Header';
import AntDesign from 'react-native-vector-icons/AntDesign';
import OrdersModal from './components/OrdersModal/OrdersModal';
import NFModal from './components/NFModal/NFModal';
import TransitModal from './components/TransitModal/TransitModal';
import {useNavigation} from '@react-navigation/native';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import {NavigationProps} from '../../navigation/Routes';
import {AppRoutes} from '../../navigation/Routes.types';
import {useAuthStore} from '../../../src/store/AuthStore';
import {useUserStore} from '../../store/UserStore';
import TemporaryPasswordBanner from '../../components/TemporaryPasswordBanner/TemporaryPasswordBanner';
import moment from 'moment-timezone';
import OrdersService from '../../services/OrdersService/OrdersService';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import {
  getPaymentMethodLabel,
  formatDeliveryDate,
} from '../../utils/orderFormat';

interface IOrderCard {
  item: IStatusPedido;
  onPress: () => void;
  returnSort: (val: string) => void;
}

const OrderDetails = ({route}) => {
  const isDesktop = useIsDesktop();
  const {item} = route?.params;
  // Forma de pagamento (amigavel) e data provavel de entrega vindas do proprio
  // pedido. A data de entrega exibida agora usa DT_REMESSA; a consulta
  // OrderDeliveryDate segue apenas para as janelas de cancelar/trocar.
  const formaPagamento = getPaymentMethodLabel(
    item?.Status?.FORM_PGT ?? item?.FORM_PGT,
  );
  const dataEntrega = formatDeliveryDate(
    item?.Status?.DT_REMESSA ?? item?.DT_REMESSA,
  );
  const [drop, setDrop] = useState<boolean>(false);
  const [showOrdersModal, setShowOrdersModal] = useState<boolean>(false);
  const [arrSteps, setArrSteps] = useState();
  const [showNfModal, setShowNfModal] = useState<boolean>(false);
  const [showTransitModal, setShowTransitModal] = useState<boolean>(false);

  const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);

  const [canCancel, setCanCancel] = useState(false);
  const [canExchange, setCanExchange] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [holidaysLoading, setHolidaysLoading] = useState(true);
  const [deliveryDate] = useState(
    item?.Status?.DT_REMESSA ?? item?.DT_REMESSA ?? '',
  );
  const [paymentId, setPaymentId] = useState('');

  const handleCloseOrdersModal = () => {
    setShowOrdersModal(false);
  };
  const {navigate} = useNavigation<NavigationProps>();

  const {goBack} = useNavigation();

  const handleOpenOrdersModal = step => {
    if (item.Itens.length === 0) return;
    if (step?.name === 'cor_ped') {
      setShowOrdersModal(true);
    }
    if (step?.name === 'cor_faturado' && step?.status === 'success') {
      setShowNfModal(true);
    }
    if (
      step?.name === 'cor_encaminhado' &&
      (step?.status === 'success' || step?.status === 'info')
    ) {
      setShowTransitModal(true);
    }
  };

  function colors(status) {
    let cor_ped = '';
    let cor_analise = '';
    let cor_faturado = '';
    let cor_separacao = '';
    let cor_encaminhado = '';
    let cor_entregue = '';

    switch (status) {
      case 'CANCELADO':
      case 'PEDIDO CANCELADO':
      case 'PEDIDO NAO FATURADO':
      case 'PEDIDO NOTA CANCELADA':
      case 'PEDIDO RETORNADO':
      case 'RETORNADO/DEVOLVIDO':
        cor_ped = 'danger';
        break;

      case 'PARCIALMENTE ENTREGUE':
      case 'PEDIDO PARCIALMENTE RECUSADO':
      case 'PEDIDO PARCIALMENTE RETORNADO':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'success';
        cor_separacao = 'success';
        cor_encaminhado = 'success';
        cor_entregue = 'warning';
        break;

      case 'PEDIDO ENTREGUE':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'success';
        cor_separacao = 'success';
        cor_encaminhado = 'success';
        cor_entregue = 'success';
        break;

      case 'PEDIDO FATURADO':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'success';
        break;

      case 'PEDIDO EM SEPARACAO':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'success';
        cor_separacao = 'info';
        break;

      case 'PEDIDO RECEBIDO':
      case 'PEDIDO CONFIRMADO':
        cor_ped = 'success';
        cor_analise = 'off';
        break;

      case 'PEDIDO EM TRANSITO':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'success';
        cor_separacao = 'success';
        cor_encaminhado = 'info';
        break;

      case 'FINANCEIRO APROVADO':
        cor_ped = 'success';
        cor_analise = 'success';
        break;

      case 'FATURAMENTO PENDENTE':
        cor_ped = 'success';
        cor_analise = 'success';
        cor_faturado = 'info';
        break;

      case 'FINANCEIRO NAO APROVADO':
      case 'PEDIDO EM PROCESSAMENTO':
        cor_ped = 'success';
        cor_analise = 'info';
        break;

      default:
        break;
    }

    return {
      cor_ped,
      cor_analise,
      cor_faturado,
      cor_separacao,
      cor_encaminhado,
      cor_entregue,
    };
  }

  const orderSteps = [
    'PEDIDO CONFIRMADO',
    'ANALISE DE CREDITO',
    'PEDIDO FATURADO',
    'SEPARACAO INTERNA',
    'PEDIDO EM TRANSITO',
    'PEDIDO ENTREGUE',
  ];

  const returnFormattedStatus = {
    cor_ped: 'Pedido Confirmado',
    cor_analise: 'Análise de Crédito',
    cor_faturado: 'Emissão de Nota e/ou Boleto',
    cor_separacao: 'Separação Interna',
    cor_encaminhado: 'Pedido em Trânsito',
    cor_entregue: 'Pedido Entregue',
  };

  const verifyOrderType = {
    ZS03: 'Bonificação',
    ZS11: 'Troca',
    ZS43: 'Compra',
    ZS07: 'Devolução',
  };

  useEffect(() => {
    const result = colors(item?.Status?.STATUS);
    const arrayDeObjetos = Object.entries(result).map(([key, value]) => ({
      name: key,
      status: value,
    }));
    setArrSteps(arrayDeObjetos);

    if (item?.Status?.STATUS == 'FINANCEIRO NAO APROVADO') {
      item.Status.STATUS = 'PEDIDO EM PROCESSAMENTO';
    }
  }, [item?.Status?.STATUS]);

  const currentIndex = orderSteps.indexOf(item?.Status?.STATUS);
  const getFirstBEZEI = () => {
    let status = '';
    if (item?.Itens?.Item?.length) {
      status = item?.Itens?.Item?.find(current => !!current.BEZEI)?.BEZEI || '';
    } else if (item?.Itens?.Item?.BEZEI) {
      status = item?.Itens?.Item?.BEZEI || '';
    }
    if (Array.isArray(status)) {
      return '';
    }
    return status.endsWith('por')
      ? status.trim().slice(0, -3)
      : status.endsWith('solicitado p')
      ? status.trim().slice(0, -2)
      : status;
  };

  const isCanceled = status => {
    switch (status) {
      case 'CANCELADO':
      case 'PEDIDO CANCELADO':
      case 'PEDIDO NAO FATURADO':
      case 'PEDIDO NOTA CANCELADA':
      case 'PEDIDO RETORNADO':
      case 'RETORNADO/DEVOLVIDO':
        return true;
      default:
        return false;
    }
  };

  const isFinished = status => {
    switch (status) {
      case 'PEDIDO ENTREGUE':
      case 'PEDIDO EM TRANSITO':
      case 'PARCIALMENTE ENTREGUE':
      case 'PEDIDO PARCIALMENTE RECUSADO':
      case 'PEDIDO PARCIALMENTE RETORNADO':
        return true;
      default:
        return false;
    }
  };

  const {clientCode} = useAuthStore().user;

  useEffect(() => {
    const isEarlyStatus = ['PEDIDO CONFIRMADO', 'PEDIDO RECEBIDO'].includes(item?.Status?.STATUS);
    if (!!paymentId && !isEarlyStatus) {
      return;
    }
    if (!!deliveryDate) {
      const orderDate = moment.tz(
        deliveryDate,
        'YYYY-MM-DD',
        'America/Sao_Paulo',
      );
      const now = moment.tz('America/Sao_Paulo');
      const daysDifference = now.diff(orderDate, 'days');

      if (daysDifference >= 8) {
        setCanExchange([false, false, false, false]);
      } else if (daysDifference >= 3) {
        setCanExchange([false, false, true, true]);
      } else {
        setCanExchange([true, true, true, true]);
      }
    }

    if (!!deliveryDate && !!holidays && !holidaysLoading) {
      const orderDate = moment.tz(
        deliveryDate,
        'YYYY-MM-DD',
        'America/Sao_Paulo',
      );

      let cutoffTime = orderDate
        .clone()
        .subtract(1, 'day')
        .set({hour: 4, minute: 0, second: 0});

      const holidayDays = holidays.map(h =>
        moment.tz(h.day, 'America/Sao_Paulo').format('YYYY-MM-DD'),
      );

      while (
        cutoffTime.day() === 0 ||
        holidayDays.includes(cutoffTime.format('YYYY-MM-DD'))
      ) {
        cutoffTime.subtract(1, 'day').set({hour: 4, minute: 0, second: 0});
      }

      const now = moment.tz('America/Sao_Paulo');

      if (cutoffTime && cutoffTime.isValid() && !holidaysLoading) {
        setCanCancel(!now.isAfter(cutoffTime));
      }
    }
  }, [deliveryDate, holidays, holidaysLoading, paymentId]);

  useEffect(() => {
    if (item['@attributes']?.ORDEM && clientCode) {
      getDeliveryDate();
    }
  }, [item]);

  const getDeliveryDate = async () => {
    await OrdersService.OrderDeliveryDate(
      clientCode,
      item['@attributes']?.ORDEM,
    )
      .then(res => {
        if (res) {
          // deliveryDate ja vem de item?.Status?.DT_REMESSA (ver useState acima).
          // O backend nao retorna DeliveryDay nesta consulta, que serve apenas
          // para alimentar Holidays/PaymentId das janelas de cancelar/trocar.
          setPaymentId(res?.PaymentId || '');
          setHolidays(res?.Holidays ? res?.Holidays : []);
          setHolidaysLoading(false);
        }
      })
      .catch(err => {
        alert(err.response?.data?.error || err);
        setHolidaysLoading(false);
      });
  };

  return (
    <View style={[styles.container, isDesktop && { maxWidth: 800, alignSelf: 'center', width: '100%' }]}>
      <Header />

      <TemporaryPasswordBanner />
      <View style={styles.containerHeader}>
        <SearchHeader onPress={goBack} title="Detalhes do pedido" />
        {!!item['@attributes']?.ORDEM && (
          <>
            <Text style={styles.description}>
              Ordem: {item['@attributes']?.ORDEM}
            </Text>
            <Text style={styles.description}>
              Data de criação:{' '}
              {moment(item?.Status?.ERDAT, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            </Text>
            <Text style={styles.description}>
              Tipo: {verifyOrderType[item?.Status?.AUART]}
            </Text>
            {!!formaPagamento && (
              <Text style={styles.description}>
                Forma de pagamento: {formaPagamento}
              </Text>
            )}
            {!isCanceled(item?.Status?.STATUS) && !!dataEntrega && (
              <Text style={styles.description}>
                Possível data de entrega: {dataEntrega}
              </Text>
            )}
          </>
        )}
        <View
          style={{
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
            marginBottom: 10,
            marginTop: 25,
          }}
        />
      </View>

      <View style={styles.content}>
        {arrSteps?.map((step, index) => {
          const isCompleted = index <= currentIndex;
          const isToOpen = !(item?.Status?.STATUS === 'PEDIDO RETORNADO');

          if (step?.status === 'off') {
            return;
          }

          return (
            <TouchableOpacity
              key={index}
              onPress={() => handleOpenOrdersModal(step)}
              style={
                index === orderSteps.length - 1
                  ? {...styles.progress}
                  : {...styles.progress, borderLeftWidth: 2}
              }>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <View style={styles.Check}>
                  {step?.status === 'success' ? (
                    <AntDesign
                      name="checkcircle"
                      size={20}
                      color={Colors.GreenPallete.greenOne}
                    />
                  ) : step?.status === 'info' ? (
                    <AntDesign
                      name="clockcircle"
                      size={22}
                      color={Colors.BluePallete.blue}
                    />
                  ) : step?.status === 'warning' ? (
                    <AntDesign
                      name="exclamationcircle"
                      size={22}
                      color={Colors.OrangePallete.orange}
                    />
                  ) : step?.status === 'danger' ? (
                    <AntDesign
                      name="closecircle"
                      size={22}
                      color={Colors.RedPallete.red}
                    />
                  ) : (
                    <FontAwesome
                      name="circle-o"
                      size={24}
                      color={Colors.GrayPallete.lightgrayTwo}
                    />
                  )}
                </View>
                <Text
                  style={
                    !!step.status
                      ? {...styles.OrderText}
                      : {...styles.OrderTextGray}
                  }>
                  {!!step.status && step.status !== 'success'
                    ? item?.Status?.STATUS?.toLowerCase().replace(
                        /\b\w/g,
                        char => char.toUpperCase(),
                      )
                    : returnFormattedStatus[step?.name]}
                </Text>
                {(step?.name === 'cor_ped' && isToOpen) ||
                (step?.name === 'cor_faturado' && step?.status === 'success') ||
                (step?.name === 'cor_encaminhado' &&
                  (step?.status === 'success' || step?.status === 'info')) ? (
                  <TouchableOpacity
                    onPress={() => handleOpenOrdersModal(step)}
                    style={{
                      marginLeft: 8,
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                    }}>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        color: Colors.RedPallete.red,
                        fontSize: 14,
                        textDecorationLine: 'underline',
                      }}>
                      Ver Detalhes
                    </Text>
                  </TouchableOpacity>
                ) : null}
              </View>
            </TouchableOpacity>
          );
        })}
      </View>

      {!isCanceled(item?.Status?.STATUS) &&
        !isFinished(item?.Status?.STATUS) &&
        !!canCancel && (
          <View
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 'auto',
              ...(isDesktop ? { maxWidth: 400, alignSelf: 'center', width: '100%' } : {}),
            }}>
            <ButtonComponent
              outlined={true}
              title="Cancelar Pedido"
              width="100%"
              disabled={temporaryPasswordLogin}
              onPress={() =>
                navigate(AppRoutes.CANCEL_ORDER, {
                  item: {...item, type: verifyOrderType[item?.Status?.AUART]},
                  canCancel: canCancel,
                })
              }
            />
          </View>
        )}

      {((!isCanceled(item?.Status?.STATUS) &&
        isFinished(item?.Status?.STATUS) &&
        !!canExchange.length &&
        !!deliveryDate &&
        canExchange.some(value => value === true)) ||
        clientCode == '0000536034') && (
        <View
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            marginTop:
              !isCanceled(item?.Status?.STATUS) &&
              !isFinished(item?.Status?.STATUS) &&
              !!canCancel
                ? 10
                : 'auto',
            ...(isDesktop ? { maxWidth: 400, alignSelf: 'center', width: '100%' } : {}),
          }}>
          <ButtonComponent
            outlined={true}
            title="Trocar Produto"
            width="100%"
            onPress={() =>
              navigate(AppRoutes.EXCHANGE_PRODUCT, {
                item: item,
                canExchange: canExchange,
              })
            }
          />
        </View>
      )}

      <OrdersModal
        returnSort={(val: string) => returnSort(val)}
        item={item}
        visible={showOrdersModal}
        onRequestClose={handleCloseOrdersModal}
      />
      <NFModal
        item={item}
        visible={showNfModal}
        onRequestClose={() => setShowNfModal(false)}
      />
      <TransitModal
        item={item}
        visible={showTransitModal}
        onRequestClose={() => setShowTransitModal(false)}
      />
    </View>
  );
};

export default OrderDetails;
